import { Divider, Grid2, Paper, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import * as Yup from 'yup';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';

import { InputMaskCustom } from '../../../Components/Form/InputMask';
import { Radio } from '../../../Components/Form/Radio/radio-input.component';
import { CreateCustomersUseCase } from '../../../Usecase/Customers/create-customers-usecase';
import { ShowCustomersUseCase } from '../../../Usecase/Customers/show-customers-usecase';
import { UpdateCustomersUseCase } from '../../../Usecase/Customers/update-customers-usecase';
import { useCreateCustomers } from './customers-create.hook';
import InputMaskComponent from '../../../Components/Form/InputMask/input-mask.component';
import { Flex } from '../../../Components/Flex/flex.component';
import AddressModal from '../../../Components/Modals/variants/address/address-variant.component';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import { watch } from 'fs';
import { InputCurrency } from '../../../Components/Form/InputCurrency/input-currency.component';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Table } from '../../../Components/Table/table.component';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { SearchAddressesUseCase } from '../../../Usecase/Addresses/search-addresses-usecase';
import { CreateAddressesUseCase } from '../../../Usecase/Addresses/create-addresses-usecase';
import { UpdateAddressesUseCase } from '../../../Usecase/Addresses/update-addresses-usecase';
import { DestroyAddressesUseCase } from '../../../Usecase/Addresses/destroy-addresses-usecase';
import { Can } from '../../../Components/Can';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { CreateCustomerPaymentPreferencesUseCase } from '../../../Usecase/CustomerPaymentPreferences/create-customer-payment-preferences-usecase';
import { UpdateCustomerPaymentPreferencesUseCase } from '../../../Usecase/CustomerPaymentPreferences/update-customer-payment-preferences-usecase';
import { DestroyCustomerPaymentPreferencesUseCase } from '../../../Usecase/CustomerPaymentPreferences/destroy-customer-payment-preferences-usecase';


  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });



  interface ICustomersFormProps {
    createCustomersUseCase: CreateCustomersUseCase
    showCustomersUseCase: ShowCustomersUseCase
    updateCustomersUseCase: UpdateCustomersUseCase
    searchAddressesUseCase: SearchAddressesUseCase
    createAddressesUseCase: CreateAddressesUseCase
    updateAddressesUseCase: UpdateAddressesUseCase
    destroyAddressesUseCase: DestroyAddressesUseCase
    createCustomerPaymentPreferencesUseCase: CreateCustomerPaymentPreferencesUseCase
    updateCustomerPaymentPreferencesUseCase: UpdateCustomerPaymentPreferencesUseCase
    destroyCustomerPaymentPreferencesUseCase: DestroyCustomerPaymentPreferencesUseCase
  }
const CustomersForm : FC<ICustomersFormProps> = ({ createCustomersUseCase, showCustomersUseCase, updateCustomersUseCase, searchAddressesUseCase, createAddressesUseCase, updateAddressesUseCase, destroyAddressesUseCase, createCustomerPaymentPreferencesUseCase, updateCustomerPaymentPreferencesUseCase, destroyCustomerPaymentPreferencesUseCase }) => {

    const {handleAction, handleSubmit, loading, register, errors, data, customerType, CustomerTypeOptions, control, setShowNewAddressModal, showNewAddressModal, setAddressSelected, addressSelected, handleNewLocalAddress, addresses, list, setAddressToDestroy, addressToDestroy, handleDestroyAddress, handleUpdateAddress, fromEdit, handleCreateNewAddress, customerId, handleUpdateLocalAddress, handleDestroyLocalAddress, typePayment, TicketEmissionBankOptions, handleAddNewPayment,payments, setPayments, watch, handleRemovePayment } = useCreateCustomers({
      createCustomersUseCase,
      showCustomersUseCase,
      updateCustomersUseCase,
      createAddressesUseCase,
      updateAddressesUseCase,
      destroyAddressesUseCase,
      createCustomerPaymentPreferencesUseCase,
      updateCustomerPaymentPreferencesUseCase,
      destroyCustomerPaymentPreferencesUseCase
    })


    const columns = useMemo(() => {
        const createColumns: any[] = [
        
            {
            field: 'name',
            headerName: 'Endereço',
            flex: 1
            },
            {
            field: 'number',
            headerName: 'Número',
            width: 200
            
            },
            {
            field: 'complement',
            headerName: 'Complemento',
            width: 200,
            valueFormatter: (value: string | null | undefined) => value || '----'
            },
            {
            field: 'city',
            headerName: 'Cidade',
            width: 300
            
            },
            {
            field: 'province',
            headerName: 'Estado',
            width: 80
            
            },
            {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            flex: 1,
            renderCell: (params: any) => <ActionButtons params={params ?? {}} setItemToDestroy={() => setAddressToDestroy(params?.row?.id)} editFunction={() => setAddressSelected(params?.row ?? {})} />
            }
        ];
        
        return createColumns;
    }, []);

    
    return (
        <Can permissions={['menu:customers:manage']}>
        <BaseScreen>

        <ConfirmDialog 
            title='Remover Endereço' 
            onCancel={() => setAddressToDestroy('')} 
            description='Você tem certeza?' 
            open={!!addressToDestroy} 
            onConfirm={fromEdit ? handleDestroyAddress : handleDestroyLocalAddress} 
        /> 

        {(showNewAddressModal || addressSelected?.id) && <AddressModal handleCreateNewAddress={handleCreateNewAddress} customerId={customerId}  fromEdit={fromEdit} searchAddressesUseCase={searchAddressesUseCase} addressSelected={addressSelected}  onClose={() => {
            setShowNewAddressModal(false)
            setAddressSelected(undefined)
        }} handleNewLocalAddress={handleNewLocalAddress} handleUpdateLocalAddress={handleUpdateLocalAddress} handleUpdateAddress={handleUpdateAddress} />}
        
         
            <Paper sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <BaseContentPage 
                    title={fromEdit ? 'Editar Cliente' : 'Novo Cliente'}
                    breadcrumb={[{ title: 'Clientes', link: "/customers-list"}, { title: fromEdit ? 'Editar Cliente' : 'Novo Cliente'}]}
                    minHeight="auto"
                    backButton
                    backUrl="/customers-list"
                >

                {loading && <Loader />}

                <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                <Grid2 size={6}>
                    <Input
                        label="Nome"
                        placeholder="Preencha o nome"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name')}
                        
                    />
                </Grid2>

                <Grid2 size={6}>
                    <Input
                        label="Razão Social"
                        placeholder="Preencha a Razão Social"
                        error={!!errors.companyName}
                        helperText={errors.companyName?.message}
                        {...register('companyName')}
                        
                    />
                </Grid2>

                <Grid2 size={6}>
                <Input
                        label="E-mail"
                        placeholder="Preencha o e-mail"
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        {...register('email')}
                        
                    />
                </Grid2>

                <Grid2 size={6}>
                    <InputMaskComponent
                      label='Telefone'
                      
                      helperText={errors?.phone?.message}
                      error={!!errors?.phone}
                      placeholder="Preencha o Telefone"
                      mask='(99)99999-9999'
                      name="phone"
                      control={control}
                      
                  />
                </Grid2>

                  {/* <Grid2 size={12}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <Radio
                            label="Tipo de cliente"
                            labelStyle={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px'}}
                            name="type"
                            control={control}
                            options={CustomerTypeOptions}
                            error={!!errors.type}
                            helperText={errors?.type?.message}
                            flex
                        />   
                </Grid2> */}

         
                    <>
                        <Grid2 size={6}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <InputMaskComponent
                                label="CNPJ"
                                helperText="Preencha o CNPJ"
                                placeholder="Preencha o CNPJ"
                                mask='99.999.999/9999-99'
                                name="document"
                                control={control}
                            />
                            
                            
                        </Grid2>

                        {/* {customerType === 'PJ' && (
                            <Grid2 size={4}>
                            <Input
                                    label="Inscrição Estadual"
                                    placeholder="Preencha a Inscrição Estadual (se houver)"
                                    error={!!errors.stateRegistration}
                                    helperText={errors.stateRegistration?.message}
                                    {...register('stateRegistration')}
                                    
                                    
                                />
                            </Grid2>
                        )} */}
                        <Grid2 size={6}>
                            <Input
                                label="Inscrição Estadual"
                                placeholder="Preencha a Inscrição Estadual (se houver)"
                                error={!!errors.stateRegistration}
                                helperText={errors.stateRegistration?.message}
                                {...register('stateRegistration')}
                                
                                
                            />
                        </Grid2>
                        
                    </>
                



                <Grid2 size={12} mt='50px'>
                    <Flex justifyContent='space-between' alignItems='center'>
                        <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Pagamentos</Typography>
                        <Button 
                            variant='outlined' 
                            // onClick={() => setShowProductsModal(true)} 
                            onClick={handleAddNewPayment} 
                            sx={{ width: '320px' }} 
                            isLoading={loading}
                        >Adicionar Forma de Pagamento</Button>
                    </Flex>
                    <Divider sx={{ margin: '10px 0'}} />

                
                    
                    <Grid2 size={12}>
                            {payments?.length ? payments?.map((i, index) => (
                                <Grid2 size={12} container spacing={2} marginTop='20px' borderBottom='solid 1px #ccc' paddingBottom='15px'>
                                    <Grid2 size={0.2}>
                                        <Flex height='100%' alignItems='center'>
                                            <Typography>{index + 1}.</Typography>
                                        </Flex>
                                       
                                    </Grid2>
                                     <Grid2 size={5}>
                                        <SelectComponent 
                                            label='Tipo de Pagamento' 
                                            options={typePayment} 
                                            control={control} 
                                            readOnly={true}
                                            defaultValue='TICKET'
                                            // error={!!errors.boxId} 
                                            placeholder=''
                                            // helperText={errors?.boxId?.message || ''} 
                                            {...register(`payment-type-${i.id}`)} 
                                        />  
                                     </Grid2>

                                    <Grid2 size={3}>
                                        <Input
                                            label="Vencimento em dias"
                                            placeholder="Preencha o vencimento em dias"
                                            // error={!!errors.}
                                            // helperText={errors.artLink?.message}
                                            {...register(`payment-days-${i.id}`)}
                                        />
                                    </Grid2>

                                    <Grid2 size={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <ButtonActionMenu options={[
                                        {
                                            title: 'Excluir',
                                            onClick: () => handleRemovePayment(i.id),
                                        }
                                        ]} />
                                       
                                    </Grid2>

                                   

                                </Grid2>
                            ))  :  <Placeholder description='Nenhum método de pagamento adicionado' sx={{ marginTop: '80px'}} /> }
                    </Grid2>

                   

                </Grid2>

                <Grid2 size={6}>
                    <SelectComponent
                        label='Banco de Emissão do Boleto'
                        options={TicketEmissionBankOptions}
                        control={control}
                        placeholder='Selecione o banco'
                        name='ticketEmissionBank'
                    />
                </Grid2>

                <Grid2 size={12} mt='50px'>
                    <Flex justifyContent='space-between' alignItems='center'>
                            <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Endereços</Typography>
                            <Button 
                                variant='outlined' 
                                onClick={() => setShowNewAddressModal(true)} 
                                
                                sx={{ width: '320px' }} 
                                isLoading={loading}
                            >Adicionar Endereço</Button>
                    </Flex>
                    <Divider sx={{ margin: '10px 0'}} />

                </Grid2>

                <Grid2 size={12}>
                    {!!list?.length ? (
                      <Table
                        data={list}
                        totalCount={list.length}
                        columns={columns}
                        pagination={false}
                        rowHeight={52}
                        onPageChange={() => {}}
                        isRowSelectable={() => false}
                        disableRowSelectionOnClick
                      />
                    ) : (
                      <Placeholder description='Nenhum endereço cadastrado.' />
                    )}
                </Grid2>

              
                <Grid2 size={12}>     

                <Button type="submit" sx={{ width: '200px' }} isLoading={loading}>
                    SALVAR
                </Button>
                </Grid2>
                </Grid2>

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { CustomersForm };
